import { Component, computed, inject, Input, OnInit} from '@angular/core';
import { Router, RouterLink } from '@angular/router';

import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { AvatarComponent } from '../avatar/avatar.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { PreferencesService } from '../../services/preferences/preferences.service';
import { UserStore } from '../../stores/users.store';

@Component({
  selector: 'app-navbar',
  imports: [RouterLink, MatMenuModule, MatButtonModule, MatToolbarModule, FaIconComponent, AvatarComponent],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css'
})
export class NavbarComponent implements OnInit {

  private readonly $preferences = inject(PreferencesService) ;
  private readonly $router = inject(Router) ;

  private user$ = inject(UserStore);

  user = this.user$.user ; 
  loading = this.user$.loading ;

  userType = this.$preferences.userType ;

  guidesUrl = computed(() => {
    if (this.userType() == 'teacher') {
      return 'https://docs.groupworkguru.com/teachers/gameface' ;
    } else {
      return 'https://docs.groupworkguru.com/students/gameface' ;
    }
  })

  @Input()
  showBrand: boolean = true ;

  ngOnInit() {
  }

  async signOut() {
    await this.user$.signOut();
    this.$router.navigate(['/']) ;
  }

  toggleDisplayMode() {
    if (this.$preferences.displayMode() == 'light') {
      this.$preferences.displayMode.set('dark') ;
    } else {
      this.$preferences.displayMode.set('light') ;
    }
  }



  async editProfile() {
    console.log(this.$router.url) ;
    await this.$router.navigate(['/edit-profile'], {queryParams: {returnUrl:this.$router.url}}) ;
  }

  async signIn() {
    console.log(this.$router.url) ;
    await this.$router.navigate(['/signin'], {queryParams: {returnUrl:this.$router.url}}) ;
  }
}
